import {
  customFormatDuration,
  DATE_FORMATS,
  DateTime,
  getDurationFromMinutes
} from "@bps/date-time";
import { TextBadge, TextBadgeColor, TextBadgeSize } from "@bps/fluent-ui";
import { WaitingListItemModel } from "@stores/booking/models/WaitingListModel.ts";

export const renderAnyBadge = (
  record: WaitingListItemModel,
  fieldName: "anyProvider" | "anyLocation"
) => {
  return (
    record[fieldName] && (
      <TextBadge
        styles={{ root: { width: 48 } }}
        badgeSize={TextBadgeSize.small}
        badgeColor={TextBadgeColor.blue}
      >
        Any
      </TextBadge>
    )
  );
};

export const renderPriority = (record: WaitingListItemModel) => {
  return record.priority;
};

export const renderDuration = (record: WaitingListItemModel) => {
  const duration =
    record.endTime && record.startTime
      ? DateTime.fromISO(record.endTime).diff(
          DateTime.fromISO(record.startTime!)
        )
      : getDurationFromMinutes(record.duration);
  return customFormatDuration(duration);
};

export const renderListExpiry = (record: WaitingListItemModel) => {
  return DateTime.fromISO(record.until).toDayDefaultFormat();
};

export const getInterpreterLanguage = (record: WaitingListItemModel) => {
  return record.contact?.model?.interpreterLanguageValue;
};

export const renderPatientPrimaryContact = (record: WaitingListItemModel) => {
  return record.contact?.model?.primaryCommunication?.value;
};

export const renderAppointmentType = (record: WaitingListItemModel) => {
  return record.appointmentType?.name;
};

export const renderProvider = (record: WaitingListItemModel) => {
  return record.user?.model?.fullName;
};

export const renderAppointmentDateTime = (record: WaitingListItemModel) => {
  if (record.startTime) {
    const today = DateTime.now().toString();
    const appointmentDateTime = DateTime.fromISO(
      record.startTime
    ).toDayDefaultFormat();
    if (appointmentDateTime === today) return "Today";
    else
      return DateTime.fromISO(record.startTime).toFormat(
        DATE_FORMATS.LONG_DATE_TIME_FORMAT
      );
  }
  return null;
};

export const renderComment = (record: WaitingListItemModel) => record.content;
